export default {
    companyIdentificationMask: "00.000.000/0000-00",
    userIdentificationMask: "000.000.000-00",
    userIdentificationMaskWithExtraZero: "000.000.000-000",
    dateMask: "dd/MM/yyyy",
}
